import {Stack, Typography, Box, useTheme} from '@mui/material';
import { memo } from 'react'
import renderWithdrawStatus from '@/hook/useRenders';
import {WITHDRAW_STATUS} from "@/constant/Constant.ts";
import RpIcon from "@/components/RpIcon";
import useRenders from "@/hook/useRenders";

const StatusLabel = (props) => {
  const {status, type} = props;
  const theme = useTheme();
  const {renderWithdrawStatus} = useRenders();
  const statusText = renderWithdrawStatus(status);

  let color = '';
  let backgroundColor = '';

  switch (status) {
    case WITHDRAW_STATUS.Waiting:
      color = theme.palette.warning.main;
      backgroundColor = theme.palette.background.warning;
      break;
    case WITHDRAW_STATUS.Pending:
      color = theme.palette.warning.main;
      backgroundColor = theme.palette.background.warning;
      break;
    case WITHDRAW_STATUS.Success:
      color = theme.palette.success.main;
      backgroundColor = theme.palette.background.success;
      break;
    case WITHDRAW_STATUS.Fail:
      color = theme.palette.error.main;
      backgroundColor = theme.palette.background.error;
      break;
    case WITHDRAW_STATUS.Canceled:
      color = theme.palette.text.secondary;
      backgroundColor = theme.palette.background.card;
      break;
    default:
      break;
  }

  let _iconName = '';
  if (status == WITHDRAW_STATUS.Waiting || status == WITHDRAW_STATUS.Pending) {
    _iconName = 'clock';
  } else if (status == WITHDRAW_STATUS.Success) {
    _iconName = 'check-circle-thin';
  } else if (status == WITHDRAW_STATUS.Fail) {
    _iconName = 'close-circle';
  } else if (status == WITHDRAW_STATUS.Canceled) {
    _iconName = 'info-circle';
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      sx={type === 'detail' ? {borderRadius: '32px', backgroundColor: backgroundColor, padding: '4px 12px', maxWidth: 'fit-content' } : {}}
    >
      {type === 'detail' ? (
        <RpIcon color={color} icon={_iconName} size={16} />
      ) : (
        <Box component="i" sx={{width: '4px', height: '4px', borderRadius: '50%', backgroundColor: color}}></Box>
      )}
      <Typography fontSize={'13px'} sx={{color: color}} {...props}>{statusText}</Typography>
    </Stack>
  );
};

export default memo(StatusLabel);